module.exports = {"audiences":["allMembers"],"experimentVersion":"v1","experimentAllocation":0.1,"defaultWeight":1,"defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/autosaveDescription.json
// module id = plGI
// module chunks = 1